import { ImageName } from "@mcleod/images";
import { Button } from "../button/Button";
import { ButtonVariant } from "../button/ButtonVariant";
import { DesignerToolsTableCell } from "./DesignerToolsTableCell";
import { Event } from "../../events/Event";
import { HeadingTableCell } from "./HeadingTableCell";
import { TableCellProps } from "./TableCellProps";

export class DesignerToolsHeadingTableCell extends HeadingTableCell {
    private buttonAddColumn: Button;

    constructor(props?: Partial<TableCellProps>) {
        super({
            ...props,
            fixedWidth: DesignerToolsTableCell.FIXED_WIDTH,
            id: "columnHeaderDesignerTools",
            paddingBottom: 0,
            paddingLeft: 2,
            paddingRight: 2,
            paddingTop: 0
        });

        this.createAddColumnButton();
        this.add(this.buttonAddColumn);
    }

    private createAddColumnButton() {
        this.buttonAddColumn = new Button({            
            color: "primary",
            fillHeight: true,
            imageHeight: 20,
            imageName: ImageName.circleAdd,
            margin: 0,
            padding: 8,
            tooltip: "Add a new column to this table",
            variant: ButtonVariant.round,
            imageWidth: 20
        });
        this.buttonAddColumn.addDragOverListener((event: Event) => event.preventDefault());
        this.buttonAddColumn.addClickListener(() => this.table._designer.addTableColumn(this.table));
    }

    public override get selectableInDesigner(): boolean {
        return false;
    }

    protected override isResizable(): boolean {
        return false;
    }

    override isSerialized(): boolean {
        return false;
    }
}
